import { buildVenueAnalysisStreamSlice } from 'widgets/venueAnalysis/store/stream/streamSlice';

const { selectors: venueTypeCapsuleStreamedDataSelectors } =
    buildVenueAnalysisStreamSlice();

export { venueTypeCapsuleStreamedDataSelectors };
